import styled from "styled-components";
import { Input } from "../components/input/Input";
import { useTranslation } from "react-i18next";
import { AddressAutofill } from "@mapbox/search-js-react";
import { Spacer } from "../components/Spacer";
import "../../i18n/i18n";

export interface AddressFormProps {
  addressLine1: string;
  addressLine2: string | null;
  city: string;
  postalCode: string;
  country: string;
}

interface AddressProps {
  label: string;
  addressForm: AddressFormProps;
  onChange: (address: keyof AddressFormProps, value: string) => void;
  error?: boolean;
  onKeyDown?: (e: string) => void;
}

export const AddressForm = (props: AddressProps) => {
  const { t } = useTranslation();
  const accessToken = import.meta.env["VITE_MAPBOX_TOKEN"] as string;

  return (
    <form>
      <AddressAutofill accessToken={accessToken || ""}>
        <Input
          label={props.label}
          placeholder={t("address.placeholder.addressLine1") || ""}
          onChange={(e) =>
            props.onChange(
              "addressLine1" as keyof AddressFormProps,
              e.target.value,
            )
          }
          value={props.addressForm.addressLine1}
          error={
            !props.addressForm?.addressLine1 && props.error
              ? t("address.error.input") || ""
              : undefined
          }
          autoComplete="address-line1"
          noneBottomSpacer
          onKeyDown={(e) => props.onKeyDown && props.onKeyDown(e.key)}
        />
      </AddressAutofill>
      <Input
        placeholder={t("address.placeholder.addressLine2") || ""}
        onChange={(e) => props.onChange("addressLine2", e.target.value)}
        value={
          props.addressForm.addressLine2 ? props.addressForm.addressLine2 : ""
        }
        autoComplete="address-line2"
        noneBottomSpacer
        onKeyDown={(e) => props.onKeyDown && props.onKeyDown(e.key)}
      />
      <StyledCityAndPostalCode>
        <Input
          placeholder={t("address.placeholder.postalCode") || ""}
          onChange={(e) => props.onChange("postalCode", e.target.value)}
          value={props.addressForm.postalCode}
          error={
            !props.addressForm?.postalCode && props.error
              ? t("address.error.input") || ""
              : undefined
          }
          autoComplete="postal-code"
          noneBottomSpacer
          onKeyDown={(e) => props.onKeyDown && props.onKeyDown(e.key)}
        />
        <Spacer x={0.5} />
        <Input
          placeholder={t("address.placeholder.city") || ""}
          onChange={(e) => props.onChange("city", e.target.value)}
          value={props.addressForm.city}
          error={
            !props.addressForm?.city && props.error
              ? t("address.error.input") || ""
              : undefined
          }
          autoComplete="address-level2"
          noneBottomSpacer
          onKeyDown={(e) => props.onKeyDown && props.onKeyDown(e.key)}
        />
      </StyledCityAndPostalCode>
      <StyledCountry>
        <Input
          value={t("address.country.france") + " 🇫🇷"}
          //autoComplete="country"
          disabled={true}
        />
        <Spacer x={0.25} />
      </StyledCountry>
    </form>
  );
};
const StyledCityAndPostalCode = styled.div`
  display: flex;
`;
const StyledCountry = styled.div`
  display: flex;
  width: 50%;
`;
